import _ from "lodash";
import { appConfig } from "config/initializers/config.app";

export const FETCH_ALL_USERS = "FETCH_ALL_USERS";
export const FETCH_ALL_COURSES = "FETCH_ALL_COURSES";
export const UPDATE_APP_CONFIG = "UPDATE_APP_CONFIG";
export const RESET_APP_CONFIG = "RESET_APP_CONFIG";
export const FETCH_ALL_TICKETS = "FETCH_ALL_TICKETS";
/*
 * Action Creators
 */

function _fetchUsers(status, err, data) {
    return {
        type: FETCH_ALL_USERS,
        status,
        err,
        data,
    };
}
function _fetchAllCourses(status, err, data) {
    return {
        type: FETCH_ALL_COURSES,
        status,
        err,
        data,
    };
}
function _updateAppConfig(status, err, data) {
    return {
        type: UPDATE_APP_CONFIG,
        status,
        err,
        data,
    };
}
function _resetAppConfig(status, err, data) {
    return {
        type: RESET_APP_CONFIG,
        status,
        err,
        data,
    };
}
function _fetchAllTickets(status, err, data) {
    return {
        type: FETCH_ALL_TICKETS,
        status,
        err,
        data,
    };
}
function getStats() {
    return (dispatch, getState, Request) => {
        return Request.fetch(appConfig.endpoints.getStatsPath, {
            method: "GET",
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return Promise.resolve(data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUsers() {
    return (dispatch, getState, Request) => {
        return Request.fetch(appConfig.endpoints.getUserListPath, {
            method: "GET",
        })
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(
                        dispatch(_fetchUsers("success", null, data))
                    );
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUserSearch(query) {
    return (dispatch, getState, Request) => {
        return Request.fetch(appConfig.endpoints.getUserSearchPath, {
            method: "POST",
            body: JSON.stringify({ query: query }),
        })
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUserQuery(query) {
    return (dispatch, getState, Request) => {
        return Request.fetch(appConfig.endpoints.getUserQueryPath, {
            method: "POST",
            body: JSON.stringify(query),
        })
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchDeactivatedUsers() {
    return (dispatch, getState, Request) => {
        return Request.fetch(appConfig.endpoints.getDeactivatedUsersPath, {
            method: "GET",
        })
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchAllCourses() {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.adminDataPaths.getAllCoursesPath + "/admin",
            {
                method: "GET",
            }
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(
                        dispatch(_fetchAllCourses("success", null, data))
                    );
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUserDetails(userId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.getUserDetailsPath
                .replace(":id", userId)
                .replace("show", "showAdmin"),
            {
                method: "GET",
            }
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUserAncestors(userId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.getUserAncestorsPath.replace(":id", userId),
            {
                method: "GET",
            }
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUserDescendants(userId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.getUserDescendantsPath.replace(":id", userId),
            {
                method: "GET",
            }
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUserCourses(userId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.adminDataPaths.getLearnerCoursesPath.replace(
                ":id",
                userId
            ),
            {
                method: "GET",
            }
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function addUser(username, name, email, password, manager, trainers, details, enroll, courseId, license) {
    return (dispatch, getState, Request) => {
        let modEmail = _.chain(email).trim().toLower().value();
        let nameSplit = name.split(" ");
        return Request.fetch(
            enroll
                ? appConfig.endpoints.createAndEnrollUserPath
                : appConfig.endpoints.createUserPath,
            {
                method: "POST",
                body: JSON.stringify({
                    email: modEmail,
                    password: password,
                    first_name: _.startCase(_.toLower(nameSplit[0])),
                    last_name:
                        nameSplit[1] === undefined
                            ? " "
                            : _.startCase(_.toLower(nameSplit[1])),
                    username: username,
                    manager: manager,
                    trainers: trainers,
                    details: details,
                    license: license,
                    courseId: courseId
                }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve(userData);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function updateUserDetails(id, detailsObj) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.updateUserDetailsPath.replace(":id", id),
            {
                method: "POST",
                body: JSON.stringify({ details: detailsObj }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function updateUserManager(id, manager) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.updateUserManagerPath.replace(":id", id),
            {
                method: "POST",
                body: JSON.stringify({ manager: manager }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function updateLicense(id, licenseObj) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.updateUserLicensePath.replace(":id", id),
            {
                method: "POST",
                body: JSON.stringify(licenseObj),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function activateUser(id) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.activateUserPath.replace(":id", id),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function deactivateUser(id) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.deactivateUserPath.replace(":id", id),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function deleteUser(id) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.deleteUserPath.replace(":id", id),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function enrollUser(courseId, learnerObj) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.learnerManagerPaths.addLearnerPath
                .replace(":course_id", courseId)
                .replace(":id", learnerObj.id),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Enrolled");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function enrollAll(courseId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.learnerManagerPaths.enrolAllPath.replace(
                ":id",
                courseId
            ),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Enrolled");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function unenrollUser(courseId, learnerId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.learnerManagerPaths.deleteLearnerPath
                .replace(":course_id", courseId)
                .replace(":id", learnerId),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Unenrolled");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchCourseUsers(courseId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.learnerManagerPaths.getLearnersPath.replace(
                ":id",
                courseId
            ),
            {
                method: "GET",
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return Promise.resolve(data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function changeOwner(courseId, userId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.builderPaths.updateCoursePath.replace(
                ":id",
                courseId
            ),
            {
                method: "POST",
                body: JSON.stringify({ owner: userId }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return Promise.resolve(data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

function addEnrollmentRule(courseId, criteria) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.enrollmentRulePaths.addEnrollmentRule.replace(
                ":id",
                courseId
            ),
            {
                method: "POST",
                body: JSON.stringify({ criteria: criteria }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return Promise.resolve(data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

function deleteEnrollmentRule(courseId, ruleId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.enrollmentRulePaths.removeEnrollmentRule
                .replace(":course_id", courseId)
                .replace(":id", ruleId),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return Promise.resolve(data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

function runEnrollmentRule(courseId, ruleId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.enrollmentRulePaths.runEnrollmentRule
                .replace(":course_id", courseId)
                .replace(":id", ruleId),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return Promise.resolve(data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

function importAppConfig() {
    return (dispatch, getState, Request) => {
        return Request.fetch(appConfig.endpoints.getConfig)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return Promise.resolve(
                    dispatch(
                        _updateAppConfig(
                            "success",
                            null,
                            _.assign({}, appConfig, data.config, {
                                apiUrls: appConfig.apiUrls,
                            })
                        )
                    )
                );
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

function updateAppConfig(configObj) {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(_updateAppConfig("success", null, configObj))
        );
    };
}
function resetAppConfig() {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(_resetAppConfig("success", null, null))
        );
    };
}
function uploadAppConfig() {
    return (dispatch, getState, Request) => {
        return Request.fetch(appConfig.endpoints.setConfig, {
            method: "POST",
            body: JSON.stringify(getState().appConfig),
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => { })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

const fetchTags = () => {
    return (dispatch, getState, Request) => {
        let tagsPath = appConfig.endpoints.tagsPath;
        return Request.fetch(tagsPath)
            .then((response) => {
                return response.json().then((data) => {
                    return data;
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};
const createTags = (tags) => {
    return (dispatch, getState, Request) => {
        let createTagsPath = appConfig.endpoints.createTagsPath;
        return Request.fetch(createTagsPath, {
            method: "POST",
            body: JSON.stringify({ tags: tags }),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const editTag = (id, tag) => {
    return (dispatch, getState, Request) => {
        let editTagPath = appConfig.endpoints.editTagPath.replace(":id", id);
        return Request.fetch(editTagPath, {
            method: "POST",
            body: JSON.stringify(tag),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const deleteTag = (tagId) => {
    return (dispatch, getState, Request) => {
        let deleteTagPath = appConfig.endpoints.deleteTagPath.replace(
            ":id",
            tagId
        );
        return Request.fetch(deleteTagPath, {
            method: "POST",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const fetchAdverts = () => {
    return (dispatch, getState, Request) => {
        let getAdvertsPath = appConfig.endpoints.getAdvertsPath;
        return Request.fetch(getAdvertsPath)
            .then((response) => {
                return response.json().then((data) => {
                    return data;
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};
const fetchPublishedAdverts = () => {
    return (dispatch, getState, Request) => {
        let getPublishedAdvertsPath = appConfig.endpoints
            .getPublishedAdvertsPath;
        return Request.fetch(getPublishedAdvertsPath)
            .then((response) => {
                return response.json().then((data) => {
                    return data;
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};
const createAdvert = (advert) => {
    return (dispatch, getState, Request) => {
        let createAdvertPath = appConfig.endpoints.createAdvertPath;
        return Request.fetch(createAdvertPath, {
            method: "POST",
            body: JSON.stringify(advert),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const editAdvert = (id, advert) => {
    return (dispatch, getState, Request) => {
        let editAdvertPath = appConfig.endpoints.editAdvertPath.replace(
            ":id",
            id
        );
        return Request.fetch(editAdvertPath, {
            method: "POST",
            body: JSON.stringify(advert),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const deleteAdvert = (id) => {
    return (dispatch, getState, Request) => {
        let deleteAdvertPath = appConfig.endpoints.deleteAdvertPath.replace(
            ":id",
            id
        );
        return Request.fetch(deleteAdvertPath, {
            method: "POST",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const fetchTickets = () => {
    return (dispatch, getState, Request) => {
        let getTicketListPath = appConfig.endpoints.getTicketListPath;
        return Request.fetch(getTicketListPath)
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(
                        dispatch(_fetchAllTickets("success", null, data))
                    );
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};
const editTicket = (id, ticket) => {
    return (dispatch, getState, Request) => {
        let editTicketPath = appConfig.endpoints.editTicketPath.replace(
            ":id",
            id
        );
        return Request.fetch(editTicketPath, {
            method: "POST",
            body: JSON.stringify(ticket),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
function fetchCloseTicket() {
    return (dispatch, getState, Request) => {
        return Request.fetch(appConfig.endpoints.getCloseTicketPath, {
            method: "GET",
        })
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function deleteTicket(id) {
    return (dispatch, getStats, Request) => {
        let deleteTicketPath = appConfig.endpoints.deleteTicketPath.replace(
            ":id",
            id
        );
        return Request.fetch(deleteTicketPath, {
            method: "POST",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
}

function updateUser(user, detailsObj, status, parent, trainers) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.updateUserPath,
            {
                method: "POST",
                body: JSON.stringify({ username: user, details: detailsObj, active: status, manager: parent, trainers: trainers }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

function fetchAllTrainer() {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.fetchAllTrainer
        )
            .then((response) => {
                return response.json().then((data) => {
                    return data;
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

function addTrainer(trainerId, userId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.addTrainerPath.replace(":id", trainerId).replace(":user_id", userId),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const getTrainees = userId => {
    return (dispatch, getState, Request) => {
        let getTraineePath = appConfig.endpoints.adminDataPaths.getTraineesPath.replace(
            ":id",
            userId
        );
        return Request.fetch(getTraineePath)
            .then(response => {
                return response.json().then(data => {
                    return data;
                });
            })
            .catch(err => {
                return [];
            });
    };
};

function removeTrainer(trainerId, traineeId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.removeTrainerPath
                .replace(":id", trainerId)
                .replace(":user_id", traineeId),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

class AdminPanelAction {
    static getStats = getStats;
    static fetchUsers = fetchUsers;
    static fetchUserQuery = fetchUserQuery;
    static fetchUserSearch = fetchUserSearch;
    static fetchDeactivatedUsers = fetchDeactivatedUsers;
    static fetchUserDetails = fetchUserDetails;
    static fetchUserAncestors = fetchUserAncestors;
    static fetchUserDescendants = fetchUserDescendants;
    static fetchUserCourses = fetchUserCourses;
    static fetchAllCourses = fetchAllCourses;
    static addUser = addUser;
    static updateUserDetails = updateUserDetails;
    static updateUserManager = updateUserManager;
    static updateLicense = updateLicense;
    static activateUser = activateUser;
    static deactivateUser = deactivateUser;
    static deleteUser = deleteUser;
    static enrollUser = enrollUser;
    static enrollAll = enrollAll;
    static unenrollUser = unenrollUser;
    static fetchCourseUsers = fetchCourseUsers;
    static changeOwner = changeOwner;
    static addEnrollmentRule = addEnrollmentRule;
    static deleteEnrollmentRule = deleteEnrollmentRule;
    static runEnrollmentRule = runEnrollmentRule;
    static updateAppConfig = updateAppConfig;
    static resetAppConfig = resetAppConfig;
    static uploadAppConfig = uploadAppConfig;
    static importAppConfig = importAppConfig;
    static fetchTags = fetchTags;
    static createTags = createTags;
    static editTag = editTag;
    static deleteTag = deleteTag;
    static fetchAdverts = fetchAdverts;
    static createAdvert = createAdvert;
    static editAdvert = editAdvert;
    static deleteAdvert = deleteAdvert;
    static fetchTickets = fetchTickets;
    static editTicket = editTicket;
    static fetchCloseTicket = fetchCloseTicket;
    static deleteTicket = deleteTicket;
    static updateUser = updateUser;
    static fetchAllTrainer = fetchAllTrainer;
    static addTrainer = addTrainer;
    static removeTrainer = removeTrainer;
    static getTrainees = getTrainees;
    static fetchPublishedAdverts = fetchPublishedAdverts;
}

export { AdminPanelAction };
